import axios from "axios";
import { cwslapi } from "@/api/index.js";
let outLink = {
  homePage: "/",
  officeHome: "http://mf.818long.com#/", // 官网正式环境
  officeRegister: "http://mf.818long.com#/register", // 注册
  officeDownLoad: "http://mf.818long.com/#/downLoad", //下载
  officeRecharge: "http://mf.818long.com#/recharge", // 充值
  officeNews: "http://mf.818long.com#/news", // 新闻
  officeAccount: "http://mf.818long.com#/account", // 账户中心
  officeRank: "http://mf.818long.com#/rank?type=0", // 充值排行
};
const init = () => {
  const baseUrl = cwslapi.defaults.baseURL;

  if (baseUrl.indexOf("109.244.44.238:8000") == -1) {
  } else {
    outLink.officeHome = "http://testmf.818long.com/#/"; // 官网测试环境
    outLink.officeRegister = "http://testmf.818long.com/#/register"; // 官网测试注册环境
    outLink.officeDownLoad = "http://testmf.818long.com/#/downLoad"; //下载
    outLink.officeRecharge = "http://testmf.818long.com/#/recharge"; // 官网测试充值环境
    outLink.officeNews = "http://testmf.818long.com/#/news"; // 官网测试公告环境
    outLink.officeAccount = "http://testmf.818long.com/#/account"; // 官网测试账户中心环境
    outLink.officeAccount = "http://testmf.818long.com/#/rank?type=0"; // 官网测试充值排行环境
    outLink.officeRank = "http://testmf.818long.com/#/rank"; // 充值排行
  }
};
// init()
export { outLink, init };
